import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    backgroundImageMobile: PropTypes.string,
    backgroundImageDesktop: PropTypes.string,
    backgroundColor: PropTypes.string,
    backgroundGradientColor: PropTypes.string,
  },
  {},
);
